import { mutator } from 'satcheljs';
import getStore from '../store/getStore';
import * as action from '../actions/advertisingOptionsActions';
import getOptions from '../selectors/getOptions';

mutator(action.toggleAllowAccess, msg => {
    const options = getOptions();
    getStore().allowAccess = !options.allowAccess;
});

mutator(action.toggleAllowPersonalization, msg => {
    const options = getOptions();
    getStore().allowPersonalization = !options.allowPersonalization;
});

mutator(action.toggleAllowAdSelection, msg => {
    const options = getOptions();
    getStore().allowAdSelection = !options.allowAdSelection;
});

mutator(action.toggleAllowContentSelection, msg => {
    const options = getOptions();
    getStore().allowContentSelection = !options.allowContentSelection;
});

mutator(action.toggleAllowMeasurement, msg => {
    const options = getOptions();
    getStore().allowMeasurement = !options.allowMeasurement;
});

mutator(action.switchView, msg => {
    getStore().showGdprPartnerListView = msg.switchToGdprPartnerListView;
});

mutator(action.setVendorList, msg => {
    getStore().vendorList = msg.vendorList;
});

mutator(action.setOptions, msg => {
    Object.keys(msg.options).forEach(key => {
        getStore()[key] = msg.options[key];
    });
});
